import { useTranslation } from 'react-i18next';
import { ExamForm } from './ExamForm';

export const ViewExam = () => {
	const { t } = useTranslation();
	return (
		<>
			<h2>{t('viewExam')}</h2>
			<ExamForm forViewing />
		</>
	);
};
